import { useTranslation } from 'react-i18next'
import { Link2, Loader2, Upload } from 'lucide-react'

export default function MediaPickerRow({
  title,
  hint,
  previewSrc,
  emptyLabel,
  busy,
  fileInputRef,
  accept,
  onFileChange,
  onOpenUrlModal,
  previewClassName = 'w-20 h-20 rounded-theme-lg',
  frameRadiusClassName = 'rounded-theme-lg',
  previewFrameClassName = '',
  previewImgClassName = 'object-cover',
  rowClassName = '',
}) {
  const { t } = useTranslation()
  return (
    <div className={`flex flex-wrap items-start gap-4 border-b border-gray-100 pb-4 last:border-0 last:pb-0 ${rowClassName}`.trim()}>
      <div className={`flex-shrink-0 p-[3px] ${frameRadiusClassName} ${previewFrameClassName}`.trim()}>
        <div className={`border border-gray-200 bg-white overflow-hidden flex items-center justify-center ${previewClassName}`}>
          {previewSrc ? (
            <img src={previewSrc} alt="" className={`w-full h-full ${previewImgClassName}`} />
          ) : (
            <span className="text-[10px] text-gray-400 text-center px-1 leading-tight">{emptyLabel}</span>
          )}
        </div>
      </div>
      <div className="flex-1 min-w-[200px] space-y-2">
        {title ? <p className="text-sm font-medium text-gray-800">{title}</p> : null}
        {hint ? <p className="text-[11px] text-gray-500 leading-snug">{hint}</p> : null}
        <div className="flex flex-wrap items-center gap-2">
          <input ref={fileInputRef} type="file" className="hidden" accept={accept} onChange={onFileChange} />
          <button
            type="button"
            className="btn btn-secondary text-xs inline-flex items-center gap-1.5"
            disabled={busy}
            onClick={() => fileInputRef.current?.click()}
          >
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
            {t('mediaPicker.upload')}
          </button>
          <button
            type="button"
            className="btn btn-ghost text-xs inline-flex items-center gap-1.5 border border-gray-200"
            disabled={busy}
            onClick={onOpenUrlModal}
          >
            <Link2 className="w-3.5 h-3.5" />
            {t('mediaPicker.pasteUrl')}
          </button>
        </div>
      </div>
    </div>
  )
}
